import { store } from '@wajeez-web/stores/base';
import { handleDispatchResult } from '@wajeez-web/core/utils';
import { Server } from '@wajeez-web/core/api-base';

import {
  actions,
  createPolicyMultilingualAsync,
  editPolicyMultilingualAsync,
  getPolicyByIdMultilingualAsync,
} from './slices';

export const createPolicyMultilingual = async (
  data: Server.CreatePolicyV2Input,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(createPolicyMultilingualAsync(data));

  return handleDispatchResult(res, onSuccess);
};

export const editPolicyMultilingual = async (
  data: Server.EditPolicyV2Input,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(editPolicyMultilingualAsync(data));

  return handleDispatchResult(res, onSuccess);
};

export const getPolicyByIdMultilingual = async (
  id: number,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getPolicyByIdMultilingualAsync(id));

  return handleDispatchResult(res, onSuccess);
};

export const clearPolicyByIdMultilingual = async () => {
  store.dispatch(actions.clearByIdMultilingual());
};
